import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const Mtech_curriculumEle = () => {
    const calendarsData = [

        // First
        {
            cname: "Chemical Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },
        {
            cname: "2023 - Batch Onwards",
            url:"https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/CH M.Tech Curriculum.pdf",
            glow: false,
            SubHeading: true,
        },
       
        // Second
        {
            cname: "Civil Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },
        {
            cname: "Environmental and Water Resource Engineering",
            url: '#',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-EWRE-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },    
        
        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-EWRE.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },  

        // third
        {
            cname: "Geotechnical Engineering",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-GTE-2020-21.pdf',
            glow: false,
            SubHeading: true
        },


        // fourth
        {
            cname: "Structural Engineering",
            url: '#',
            glow: false,
            SubHeading: true
        },

        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-SE-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2:true
        },
        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-SE.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },     

        // fifth
        {
            cname: "Transportation and Infrastructure Engineering",
            url: '#',
            glow: false,
            SubHeading: true
        },

        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-TIE-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },
        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-TIE.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },
        

        // six  
        {
            cname: "Computer Science and Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-CSE-2020-21.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/2018/Mtech/M.Tech_Curriculum_CSE.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/M.Tech_Curriculum_CSE_2018.pdf',
            glow: false,
            SubHeading: true
        },

        // seven  
        {
            cname: "Electrical Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "RF and Microwave Engineering",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-RFMWE-2022-23.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "Microelectronics and VLSI",
            url: '#',
            glow: false,
            SubHeading: true,
            SubHeading2: false

        },
        {
            cname: "2021 - 2022",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-MVLSI-2021-22.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },


        {
            cname: "Signal Processing and Communication",
            url: '#',
            glow: false,
            SubHeading: true,
            SubHeading2: false

        },
        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-SPC-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },

        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/2018/Mtech/M.Tech_Curriculum_EE.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },

        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/M.Tech_Curriculum_EE.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true
        },


        // eight  
        {
            cname: "Mechanical Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "Design & Manufacturing",
            url: '#',
            glow: false,
            SubHeading: true
        },

        {
            cname: "Indian Army Officers (2020 Batch)",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-DM-Army%20Officers-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },

        {
            cname: "2020 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-DM-2020-21.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },

        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/M.Tech_Curriculum_ME.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },

        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/2018/Mtech/M.Tech_Curriculum_ME.pdf',
            glow: false,
            SubHeading: true,
            SubHeading2: true

        },


        // nine  
        {
            cname: "Thermal Engineering and Energy Systems",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/ME%20FT%20M.Tech%20Curriculum.pdf',
            glow: false,
            SubHeading: true
        },

    
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={1} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>  
                        <h3 className='text-center mb-5'>M.Tech Curriculum</h3>
                        <h5>Curriculum for M.Tech Program (2018-2019) are listed as below:</h5>

                                <ul className='ms-4 mt-4 fs-5'>
                                    {calendarsData.map((value, index) => {
                                        return (
                                            <li className='c-lineheight3' key={index}>
                                                <span className={`${value.SubHeading ? 'ms-5' : ''}`}></span>
                                                <span className={`${value.SubHeading2 ? 'ms-4' : ''}`}></span>
                                                
                                                <i className={`${value.SubHeading2 ? 'text-orange' : 'text-danger'} fas fa-file-pdf me-3`}></i>
                                                <Link to={value.url} target="_blank">

                                                    <span className={`${value.glow ? 'test' : ''}`}>
                                                        {value.cname}
                                                    </span>
                                                    
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                    </Col>
                </Row>
            </Container>
        </section>            
     
    );
};


export default Mtech_curriculumEle;
